'use client';

import Error from 'next/error';
import { Suspense } from 'react';

// Render the default Next.js 404 page when a route
// is requested that doesn't match the middleware and
// therefore doesn't have a locale associated with it.

export default function NotFound() {
  return (
    <html>
      <body>
        <Suspense fallback={<div>Loading...</div>}>
          <Error statusCode={404} />
        </Suspense>
      </body>
    </html>
  );
}
